import React from 'react';
import '../auth.css';
import i18n from '../i18n';
import {connect} from 'react-redux'
import axios from 'axios';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import { API_BASE_URL } from "../utils/endpoints";


class FormReset extends React.Component
 {
   constructor(props)
    {
       super(props);

       this.state={oldpassword :'',password: '',isArabic :false,re_password :''};

      this.modalIsOpenError = this.modalIsOpenError.bind(this);
      this.afterOpenModalError = this.afterOpenModalError.bind(this);
      this.closeModalError = this.closeModalError.bind(this);
   }

   modalIsOpenError() {
    this.setState({ modalIsOpenError: true });
  }

  closeModalError() {
    this.setState({ modalIsOpenError: false });
  }
  afterOpenModalError() {}
    componentDidMount() {
        var lang=i18n.language;
      if(lang ==="ar")
    {
      this.setState({isArabic :true})
    }
    else{
      this.setState({isArabic :false})
    }


    }






    onoldpasswordChange=(event)=>
    {
      this.setState({oldpassword:event.target.value});
    }
    onPasswordChange=(event)=>
    {
      this.setState({password:event.target.value});
    }

    onRePasswordChange=(event)=>
    {
      this.setState({re_password:event.target.value});
    }
    resetPassword =event=>{
        event.preventDefault();
        if (this.state.oldpassword.length === 0 || this.state.password.length === 0 || this.state.re_password.length === 0)
        {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Please_fill_all_fields.label"),
            animation: "bounce",
            time: 5000
          });
        }
      /* else if (this.state.password != this.state.re_passowrd)
        {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Password_and_Re_password_not_match.label"),
            animation: "bounce",
            time: 5000
          });
        } */
        else {
          var ip = API_BASE_URL;
          var s2 = "localhost:3000";
          var apiBaseUrl;
          if (ip.includes(s2)) {
            apiBaseUrl =
              API_BASE_URL + "/core/user/rest/auth/resetpassword";
          } else {
            apiBaseUrl =
            ip + "/core/user/rest/auth/resetpassword";
          }
          var data = {};
          var headers = {
            "content-type": "application/json",
            username:reactLocalStorage.get("userNameLoggedIN"),
            old_password: this.state.oldpassword,
            new_password: this.state.password
          };
          axios
            .post(apiBaseUrl, data, { headers: headers })
            .then(function(response) {
              if (response.status === 200) {
                if (response.data.status === "success") {
                  if (response.data.result.message) {
                    toast({
                      type: "success",
                      title: i18n.t("success.label"),
                      description: response.data.result.message,
                      animation: "bounce",
                      time: 5000
                    });
                    window.location = "/app";
                  }
                }
                if(response.data.status === "failed")
                {
                  toast({
                    type: "failed",
                    title: i18n.t("failed.label"),
                    description: response.data.result.errorReposne,
                    animation: "bounce",
                    time: 5000
                  });
                  if(response.data.result.errorReposne == 'Password does not meet complexity requirements or contains username')
                  {
                    document.querySelector(".modalIsOpenError").style = "display:block";                  }
                }
              } else if (response.status === 204 ) {
                console.log("Something wrong");
              } else {
                console.log("Something wrong");
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        }
    }
   render () {
   return (
     <div>
     <form className="ui large form border radius content_form">
     <div className="stacked segment border_margin">

     <div className="modalIsOpenError" style={{display:'none'}}>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_title.label")}
                  </p>

                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point1.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point2.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point3.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point4.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point5.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point6.label")}
                  </p>

        </div>
        <br/>


<div className="">
     <div className="field">
     {this.state.isArabic ?
     <div className="ui fluid  icon input">
     <input placeholder={i18n.t('old_password.label')} type="Password" className="username" style={{textAlign:'right'}} value={this.state.oldpassword} onChange={this.onoldpasswordChange}/>
     <i aria-hidden="true" className="lock icon"></i>
     </div>
     :
     <div className="ui fluid left icon input">
     <input placeholder={i18n.t('old_password.label')} type="Password" className="username" value={this.state.oldpassword} onChange={this.onoldpasswordChange}/>
     <i aria-hidden="true" className="lock icon"></i>
     </div>
     }
     </div>
     <div className="field">


     {this.state.isArabic ?
    <div className="ui fluid  icon input">
    <input placeholder={i18n.t('Password.label')} type="Password" style={{textAlign:'right'}} className="username" value={this.state.password} onChange={this.onPasswordChange}/>
    <i aria-hidden="true" className="lock icon"></i>
    </div>
    :
<div className="ui fluid left icon input">
    <input placeholder={i18n.t('Password.label')} type="Password" className="username" value={this.state.password} onChange={this.onPasswordChange}/>
    <i aria-hidden="true" className="lock icon"></i>
    </div>
     }

    </div>

      <div className="field">

      {this.state.isArabic ?
      <div className="ui fluid  icon input">
      <input placeholder={i18n.t('re_pass.label')} type="Password" className="username" style={{textAlign:'right'}} value={this.state.re_password} onChange={this.onRePasswordChange}/>
      <i aria-hidden="true" className="lock icon"></i>
      </div>
      :
      <div className="ui fluid left icon input">
      <input placeholder={i18n.t('re_pass.label')} type="Password" className="username" value={this.state.re_password} onChange={this.onRePasswordChange}/>
      <i aria-hidden="true" className="lock icon"></i>
      </div>
      }

      </div>

    <button className="ui large fluid button btn_login radius" onClick={this.resetPassword.bind(this)}>{i18n.t('Reset_Password.label')}</button>
</div>









     </div>
     </form>
     <SemanticToastContainer/>
     </div>
          );
      }
   }


const mapStateToProps = (state)=>{
  return {...state}
}

export default connect(mapStateToProps)(FormReset);
